import { RequestsInstance } from 'api';
import { AxiosRequestConfig } from 'axios';

const DailyChallengeApiWrapper = (requests: RequestsInstance) => {
	return {
		dailyChallenges: (config?: AxiosRequestConfig) => {
			return requests.get(`/daily-challenge`, config).then((res) => res.data.data);
		},
	};
};

export default DailyChallengeApiWrapper;
